export default "__VITE_ASSET__weFB1$y___"